<template>
    <div class="invite_wrap">
        <div class="basic_wrap" style="color:white;">         
            <img src="../images/share/tbg.png" class="myteam-bg">

            <div class="top-bg">
                <div class="avta-div">
                    <img class="avta" src="../images/avt.png" alt="">
                </div>
                <!-- <p class="userphone"> {{ userinfo.mobile }} </p> -->
                <div class="uid"> ID:{{ userinfo.id }}</div>
                <div class="uid2"> {{ $t("我的邀请链接") }}</div>
                <div class="linkcode">
                    <b> {{ userinfo.invite_http }} </b>
                    <img class="copy-img" @click="doCopy(userinfo.invite_http)" src="../images/share/copy.png" style=""
                        alt="">
                </div>

            </div>
            <div class="mid_bg">
                <div class="rcdc">Recompensas cumulativas de convite</div>
                <div class="all-com"> R${{ userinfo.youxiao_user * 10}} <b>{{ $t("总计") }}</b></div>
                <p class="invi-des">Convide um jogador válido e ganhe R$10</p>
                <p class="invi-des">O que seria um jogador válido?</p>
                <p class="invi-des" style="line-height:20px;">Jogadores que fizerem uma recarga de R$20.00 e aposta de R$25.00</p>
                <div class="receive_money" @click="$router.push('/reward_list')">Ver histórico de bônus</div>
            </div>

            <div class="mid_bg" style="margin-top:0.3rem">
                <p class="invi-des" >Número total de jogadores convidados: <b style="float:right;margin-right: 10px;;font-size: 0.3rem;">{{ userinfo.all_user }}</b> </p>
                <p class="invi-des" >Número de jogadores recarregados: <b style="float:right;margin-right: 10px;font-size: 0.3rem;">{{ userinfo.recharge_count }}</b></p>
                <p class="invi-des" >Número válido de jogadores: <b style="float:right;margin-right: 10px;;font-size: 0.3rem;">{{ userinfo.youxiao_user }}</b></p>
                <p class="invi-des" >Valor total de recarga: <span style="float:right;margin-right: 10px;font-size: 0.3rem;">R${{ userinfo.recharge_total }}</span></p>
            </div>

            <div class="bottom_bg">
                <div class="ldmc">Lista de membros convidados</div>
                <!-- <div class="search-wrap">
                    <input class="input-keyword" type="text" v-model="keyword" placeholder="Consultar ID do membro">
                    <img class="simg" src="../images/home/s_a.png" alt="" >
                </div> -->
                <div class="hoho">
                    <div class="item" >
                        {{ $t("ID") }}
                    </div>
                    <div class="item" >
                        Valor da aposta
                    </div>
                    <div class="item" >
                        Valor de Recarga
                    </div>
                    <div v-for="(item, index) in subUser"  :key="index" v-show="index < max_show" >
                        <div class="item" >{{ item.id }}</div>
                        <div class="item">
                            {{ item.total_bet_amount }}
                        </div>
                        <div class="item" >
                            {{ item.total_recharge_amount }}
                        </div>
                    </div>
                </div>
                <div class="show_more" v-show="subUser.length > 10" @click="max_show+=5">Mostre mais ⇊</div>
            </div>
        </div>
    </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import bsHeader from "../../components/bsHeader.vue";
export default {
    name: "myTeam",
    data() {
        return {
            data: {
                reward: {
                    invest1: "4.00",
                    invest2: "2.00",
                    invest3: "1.00",
                },

            },
            userinfo: {},
            keyword: null,
            subUser: [],
            subUserBak: [],
            level: 'A',
            levelList: ['A', 'B', 'C'],
            show: false,
            money: 0,
            max_show:10,
        };
    },
    components: {
        bsHeader,
    },
    created() {
        this.$parent.footer("share");
    },
    mounted() {
        this.start();
        this.subUserList();
    },
    watch: {
        keyword: function (newn, old) {
            this.subUser= [];
            this.subUserBak.forEach(item => {
                if (String(item.id).toLowerCase().search(newn.toLowerCase()) != -1) {
                    this.subUser.push(item);
                }
            })
        }
    },
    methods: {
        popup_cancel() {
            this.show = false
        },
        popup_commit() {
            Fetch("/user/commissionChange", { money: this.money }).then((r) => {
                this.show = false
                console.log(r);
            });
        },
        commission_change() {
            this.show = true
        },
        getUserByType(type) {
            this.level = type;
            this.subUserList();
        },
        subUserList() {
            Fetch("/user/subLevelUser", { level: this.level }).then((r) => {
                this.subUser = r.data
                this.subUserBak = r.data

                console.log(r);
            });
        },
        doCopy(val) {
            let _this = this;
            this.$copyText(String(val)).then(
                function (e) {
                    _this.$toast({
                        background: "#07c160",
                        message: _this.$t("复制成功"),
                    });
                },
                function (e) {
                    //console.log(e);
                }
            );
        },
        search() {
            Fetch("/user/subLevel", { user_id: this.keyword }).then((r) => {
                console.log(r);
                if (r.data != "0") {
                    this.$toast({
                        //type:'fail',
                        background: "#07c160",
                        message: "YES" + ": " + r.data,
                        duration: 5000,
                        className: "mytoast"

                    });
                } else {
                    this.$toast({
                        //type:'fail',
                        background: "#07c160",
                        message: "NO",
                        duration: 5000,
                        className: "mytoast"

                    });
                }
            });
        },
        handleError() {
            this.$messagesouth({
                message: "Replication failed",
                type: "comm",
                center: true,
            });
        },
        start() {
            Fetch("/user/myTeam").then((r) => {
                //console.log(r);
                this.userinfo = r.data;
            });
        },

        copy() {
            this.$toast({
                background: "#07c160",
                message: this.$t("invest_qrcode.copySucceeded"),
            });
        },


    },
};
</script>

<style lang="less" scoped>
.show_more{
    color: #84A559;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    bottom: 0;
    text-align: center;
    font-size: 0.35rem;
}
.ldmc
{
    text-align: center;
    font-size: 0.35rem;
    margin: 0.5rem 0;
}
.myteam-bg{
    width: 100%;
    height: 4.8rem;
    position: fixed;
    top: 0;
    left: 0;
}
.invi-des {
    padding: 0.2rem 0;
    line-height: 0.35rem;
    font-weight: 700;
    font-size: 0.3rem;
}

.search-wrap {
    border: 1px solid rgba(132, 165, 89,0.8);
    height: 1rem;
    width:100%;
    margin: 5px auto;
    border-radius: 10px;

}

.simg {
    width: 0.5rem;
    float: right;
    margin-top: 0.2rem;
    margin-right: 0.3rem;
}

.input-keyword {
    width: 70%;
    height: 100%;
    color: #84A559;
    font-size:  0.3rem;
    float: left;
    margin-left: 20px;
}
.input-keyword::placeholder
{
    font-size: 0.3rem;
    color: #84A559;
}
.item {
    width: 33.33334%;
    float: left;
    height: 40px;
    line-height: 40px;
    color: #84A559;
    font-weight: 700;
    font-size: 0.28rem;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid rgb(132, 165, 89,0.5);
    overflow: hidden;
    text-align: center;
    display: block;
    margin: 0;
    border-radius: 0;
}

.hoho {
    width: 98%;
    // border: 1px solid white;
    margin: 15px auto;
    overflow: hidden;

}

.copy-img {
    margin-left: 15px;
    display: block;
    height: 25px;
    //margin: 15px auto 3px;
}

.r-wrap {
    width: 100%;
    margin: 0 auto;
    padding: 0 10px;
    background: #3a4a7c;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: linear-gradient(to right, rgb(60, 18, 71), rgb(38, 3, 27));
    border-radius: 15px;
}

.left-one {
    width: 50%;
    text-align: center;
    // height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    padding: 15px;

    border-bottom: 1px solid #090909;
}

.right-one {
    width: 50%;
    text-align: center;
    // height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    padding: 15px;
    border-left: 1px solid #090909;
    border-bottom: 1px solid #090909;
    color: gold;
    font-weight: 700;
}

.ewai {
    width: 95%;
    margin: 0 auto;
    padding: 0 10px;
    background: #3a4a7c;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: linear-gradient(to right, rgb(60, 18, 71), rgb(38, 3, 27));
    border-radius: 15px;
    //     background: url('../images/myteam/bg.png') 100% 100% no-repeat;
    //    background-size: cover;
}

.ic-rule div {
    font-size: 16px;
    margin-bottom: 5px;
    line-height: 30px;
    background: linear-gradient(to right, rgb(60, 18, 71), rgb(38, 3, 27));
    //    background: url('../images/myteam/bg.png') 100% 100% no-repeat;
    //    background-size: cover;
    padding: 10px;
    border-radius: 15px;
}

.ic-rule p {
    text-align: center;
    font-size: 16px;
    width: 50%;
    height: 38px;
    line-height: 30px;
    margin: 0 auto 8px;
    // background: url("../images/myteam/y.png") no-repeat;
    background-size: contain;
}

.ic-rule {
    width: 100%;
    padding: 10px 10px 0;
}

.all-com {
    position: relative;
    width: 99%;
    padding: 0;
    font-size: 16px;
    height: 1rem;
    line-height: 1rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(132, 165, 89,0.3);
}

.linkcode {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    margin-top: 15px;
    color: #84A559;
    display: flex;
    padding: 6px 6px;
    align-items: center;
    border-radius: 5px;
    border: 1px solid #84A559;
}

.linkcode b {
    width: 90%;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis; //文本溢出显示省略号
    white-space: nowrap; //文本不会换行
}

.uid {
    text-align: center;
    font-size: 0.35rem;
    font-weight: 700;
    margin-top: 10px;
    color: #84A559;
}

.uid2 {
    text-align: center;
    font-size: 0.35rem;
    margin-top: 10px;
    color: #84A559;
 
}

.userphone {
    text-align: center;
    font-size: 0.5rem;
    font-weight: 700;
    margin-top: 10px;
}

.avta {
    width: 80px;
    display: block;
    margin: -13px auto 3px;
}

.avta-div {
    width: 100%;
}

.top-bg {
    width: 92%;
    margin: 15px auto;
    padding-bottom: 0;
    background-size: contain;
    border-radius: 5px;
    margin-top: 1.8rem;
    padding-top: 0;
   
}

.mid_bg {
    width: 92%;
    margin: 0 auto;
    padding: 8px 15px;
    background-size: contain;
    border-radius: 10px;
    border: 1px solid #84A559;
    color: #84A559;   
}
.receive_money {
    margin: 0 auto;
    width: 50%;
    height: 0.8rem;
    line-height: 0.8rem;
    border-radius: 0.3rem;
    border: 1px solid #84A559;
    text-align: center;
    color: #85A449;
    font-size: 0.35rem;
}
.rcdc{
    font-size: 0.35rem;
}
.bottom_bg {
    width: 92%;
    margin: 15px auto;
    padding: 0;
    background-size: contain;
    border-radius: 10px;
    color: #84A559;
}

.invite_wrap {
    min-height: 100vh;
    width: 100%;
    background: url('../images/vip/sbg.png') repeat;
    padding-bottom: 1.2rem;
    
}

.copy-btn {
    width: 15%;
    box-sizing: content-box;
    color: white;
    font-size: 0.38rem;
    background: #bc9e77;
    border-radius: 8px;
    height: 30px;
    margin-top: 2.5px;
    margin-left: 50%;
}

.really-code {
    font-weight: 700;
    font-size: 0.25rem;
}

.invitation-des {
    width: 85%;
    height: 35px;
    line-height: 40px;
    font-size: 0.38rem;
    color: #635032;
}

.people-des {
    color: #635032;
}

.recharge-count {
    color: #635032;
    font-weight: 700;
    font-size: 0.45rem;
}

.mem-count {
    color: #635032;
    font-size: 0.45rem;
}

.team-members,
.team-members-2 {
    color: #9e8757;
    font-size: 0.35rem;
}

.asset-mid {
    width: 95%;
    // display: flex;
    justify-content: center;
    align-content: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0ceb1;
}

.team-members {
    // width: 60%;
    height: 20px;
    line-height: 15px;
}

.team-members-2 {
    // width: 40%;
    height: 20px;
    line-height: 15px;
}

.asset-top {
    height: 75px;
    width: 100%;
    //background: #8d8d8f;
    display: flex;
}

.asset-btm {
    height: 80px;
    width: 100%;
    //background: #8d8d8f;
    // display: flex;
}

.btm-item {
    width: 33.33%;
}

.item-money {
    text-align: center;
    height: 40px;
    line-height: 50px;
    font-weight: 700;
    font-size: 0.45rem;
    color: #635032;
}

.item-des {
    text-align: center;
    height: 15px;
    line-height: 15px;
    //font-weight: 700;
    font-size: 0.35rem;
    color: #94866b;
}

.asset-top-left {
    width: 70%;
}

.asset-top-right {
    width: 30%;
}

.total-asset {
    height: 20px;
    line-height: 20px;
    color: #9e8757;
    font-size: 0.4rem;
    font-weight: 700;
}

.total-number {
    height: 50px;
    line-height: 50px;
    color: black;
    font-weight: 700;
    font-size: 0.75rem;
}

.team-info {
    width: 96%;
    margin-left: 2%;
    background: url("../images/team_bg.png");
    background-size: cover;
    border-radius: 6px;
    padding: 10px 15px 8px 15px;
    //height: 185px;
    //text-align: center;
}

.big_tit {
    position: absolute;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 25px;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
}

.phone-number {
    height: 60px;
    line-height: 30px;
    text-indent: 8px;
    color: white;
    font-size: 0.5rem;
    font-weight: 700;
}

.userinfo {
    width: 96%;
    margin: 15px auto;
    height: 60px;
    //background: red;
    display: flex;
    //justify-content: center;
}

.red_top_bg {
    height: 44px;
    background: url(../images/login.png) no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    border-radius: 0 0 20% 20%;

    .big_tit {
        position: absolute;
    }

    .back_right {
        position: absolute;
        top: 3px;
        right: 3px;
    }

    .introduce {
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        line-height: 25px;
        color: #ffffff;
        margin-top: 20px;

        .line {
            width: 36px;
            height: 10px;
        }

        .tit {
            margin: 0 12px;
            font-weight: bold;
        }

        .left_line {
            background: url(../images/user/left_icon.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .right_line {
            background: url(../images/user/right_icon.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

    .award_tip {
        font-size: 14px;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
        margin: 3px auto 0 auto;
    }
}



</style>
